module.exports = __webpack_public_path__ + "media/images/photo/plans/places/yasaka-c6887957540fd4ceb31bb192fa40fba0.png";